import React, { Suspense } from 'react';
import { constants } from '../../../config';
import { Product, Picture } from '../../../data/models/product_list_response';
import placeholder from '../../../assets/placeholder/product_placeholder.png';
import { Link, useParams } from 'react-router-dom';
import { capitalize, formatAmount } from '../../../utility/common';
import useCart from '../../../data/hooks/cart_hook';
import { ProductAddButton } from './product_add_button';
import { ImageComponent } from '../common/image_component';

export const ProductCard = (product: Product) => {
  const { storeSlug } = useParams<any>();
  const { addToCart, removeFromCart, isItemInCart, getItemInCart } = useCart();
  let url = placeholder;
  const getImageUrl = (files: Picture[]) => {
    if (files != null) {
      if(files.length > 0){
      const file = files[0];
      url = `${constants.API}/media/MediaContent?filePath=${file.filePath}&fileName=${file.fileName}`;}
    }
    return url;
  };
  if (isItemInCart(product.storeProductId)) {
    // console.log(product);
  }
  return (
    <figure className="p-4 flex flex-col" style={{ maxWidth: 145 }}>
      <Link to={`product/${product?.storeProductId}`} className="flex-1">
        <div className="w-28 h-28 rounded-lg mx-auto">
          <ImageComponent
            src={getImageUrl(product?.productPictures)}
            htmlClass="w-28 h-28 rounded-lg"
            htmlAlt={product?.productName}
          />
        </div>
        <div className="pt-2 text-left">
          <h3 className="font-medium overflow-ellipsis line-clamp-2">{capitalize(product?.productName)}</h3>
          {product.haveVariants ? (
            <p className="font-normal text-sm">{product.productVariants.length} variants</p>
          ) : (
            <>
              <p className="font-normal text-sm">{`In stock: ${product?.quantity} ${product?.productUnit?.productUnitName}`}</p>
              <p className="font-medium text-primaryViolet mt-2">{`${formatAmount(product?.sellingPrice)}`}</p>
            </>
          )}
        </div>
      </Link>
      {<ProductAddButton key={`${product.storeProductId}-add-product`} product={product} />}
    </figure>
  );
};
